import React, { useEffect,  useRef, useState } from "react";

import { Row, Col, Button, Offcanvas } from "react-bootstrap";
import { FiMenu } from "react-icons/fi";
import ColourFilterBox from "../../../../components/FilterBox/ColourFilter/ColourFilter";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";

import { format } from "date-fns";

import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import { Loader } from "../../../../components/Loader/Loader";
import {
  ColourFilter,
  MachineWiseCosting,
  MachineWiseCostingFun,
} from "../../../../Redux/Slice/Colour/InwardAnylysis/InwardAnylysis";
import Calendar from "react-calendar";
import { useTheme } from "../../../../Themecontext/Themecontext";
import ColorCalenderCss from "../../../../components/Calendar/ColorCalenderCss";
import { color } from "echarts";

export const MachineGroupWiseCosting = () => {
  const dispatch = useDispatch();

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);

  const { MachineWiseCostingdata, ColourfilterData } = useSelector(
    (state) => state.InwardAnylysisSlice,
  );

  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICL",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICLDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const Firm = Cookies.get("Firm");

  const FinancialYear = Cookies.get("FinancialYear");

  const [showFilter, setShowFilter] = useState(false);

  const [showDatePicker, setShowDatePicker] = useState(false);

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return null;
    return format(new Date(date), "yyyy-MM-dd");
  };

  const productionGroupList =
    ColourfilterData?.ProductionGroup?.map((item) => ({
      label: item?.ProductionGroupMstName,
      value: item?.ProductionGroupMstID,
    })) || [];

  const machineGroupList =
    ColourfilterData?.MachineGroup?.map((item) => ({
      label: item?.MachineGroupMstName,
      value: item?.MachineGroupMstID,
    })) || [];

  const [filters, setFilters] = useState({
    productionGroup: [],
    machineGroup: [],
  });

  const [search, setSearch] = useState({
    productionGroup: "",
    machineGroup: "",
  });

  useEffect(() => {
    if (!startDate || !endDate) return;

    dispatch(ColourFilter());

    dispatch(
      MachineWiseCosting({
        FirmIDs: Firm,
        AcYearIDs: FinancialYear,
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
      }),
    );
  }, [Firm, FinancialYear, startDate, endDate]);

  // 🔷 Toggle
  const toggleItem = (type, item) => {
    setFilters((prev) => {
      const selected = prev[type];

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };

  // 🔷 Select All
  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };

  // 🔷 Search
  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const handleSubmit = () => {
    dispatch(MachineWiseCostingFun());

    dispatch(
      MachineWiseCosting({
        FirmIDs: Firm,
        AcYearIDs: FinancialYear,
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
        ProductionGroupIDs: filters.productionGroup.join(","),
        MachineGroupMstIDs: filters.machineGroup.join(","),
      }),
    );

    setShowFilter(false);
  };

  if (!ColourfilterData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!MachineWiseCostingdata || MachineWiseCostingdata === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }
  return (
    <div
      style={{
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
        minHeight: "100vh",
        padding: "16px",
      }}
    >

      {/* 🔥 MOBILE FILTER BUTTON */}
      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={() => setShowFilter(true)}
          style={{
            background:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            border: "none",
          }}
        >
          <FiMenu />
        </Button>
      </div>

      {/* 🔥 OFFCANVAS */}
      <Offcanvas show={showFilter} onHide={() => setShowFilter(false)}
        style={{
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,

        }}
      >
        <Offcanvas.Header closeButton
          closeVariant={isdark === "dark" ? "white" : undefined}
          style={
            {
              color: isdark === "light" ? "#000" : "#FFF",
            }
          }>
          <Offcanvas.Title>Filters</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            {/* 🔥 DATE PICKER BOX */}
            <div>
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour6
                      : iscolourDark?.Colour7,
                  padding: "13px 20px",
                  borderRadius: "12px 12px 0px 0px",
                }}
              >
                <h3
                  style={{
                    fontWeight: "700",
                    fontSize: "18px",
                    margin: 0,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour12,
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  {" "}
                  Date Range
                </h3>
              </div>
              <div
                style={{
                  border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                  padding: "15px",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour3,
                  borderRadius: "0px 0px 12px 12px",
                }}
              >
                <div
                  onClick={() => setShowDatePicker(true)}
                  style={{
                    marginTop: "8px",
                    padding: "10px",
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                    borderRadius: "10px",
                    cursor: "pointer",
                    textAlign: "center",
                    color: isdark === "light" ? "#000" : "#fff",
                  }}
                >
                  {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                    ? `${format(dateRange[0].startDate, "yyyy-MM-dd")} - ${format(dateRange[0].endDate, "yyyy-MM-dd")}`
                    : "Select Date Range"}
                </div>
              </div>
            </div>
            <ColourFilterBox
              title="Production Group"
              items={productionGroupList}
              search={search.productionGroup}
              setSearch={(val) => handleSearch("productionGroup", val)}
              selectedItems={filters.productionGroup}
              toggleItem={(item) => toggleItem("productionGroup", item)}
              selectAll={() =>
                selectAll("productionGroup", productionGroupList)
              }
            />

            <ColourFilterBox
              title="Machine Group Name"
              items={machineGroupList}
              search={search.machineGroup}
              setSearch={(val) => handleSearch("machineGroup", val)}
              selectedItems={filters.machineGroup}
              toggleItem={(item) => toggleItem("machineGroup", item)}
              selectAll={() => selectAll("machineGroup", machineGroupList)}
            />
            <Button
              onClick={handleSubmit}
              style={{
                width: "100%",
                height: "44px",
                borderRadius: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour12,
                border: "none",
                fontWeight: "700",
                padding: "12px"
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Row className="g-3">
        {/* 🔥 DESKTOP FILTER ONLY */}
        <Col xl={3} lg={4} className="d-none d-lg-block">
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            {/* 🔥 DATE PICKER BOX */}
            <div>
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour6
                      : iscolourDark?.Colour7,
                  padding: "13px 20px",
                  borderRadius: "12px 12px 0px 0px",
                }}
              >
                <h3
                  style={{
                    fontWeight: "700",
                    fontSize: "18px",
                    margin: 0,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour12
                        : iscolourDark?.Colour12,
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  {" "}
                  Date Range
                </h3>
              </div>
              <div
                style={{
                  border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                  padding: "15px",
                  marginBottom: "15px",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour3,
                  borderRadius: "0px 0px 12px 12px",
                }}
              >
                <div
                  onClick={() => setShowDatePicker(true)}
                  style={{
                    marginTop: "8px",
                    padding: "10px",
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                    borderRadius: "10px",
                    cursor: "pointer",
                    textAlign: "center",
                    color: isdark === "light" ? "#000" : "#ffff",
                  }}
                >
                  {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                    ? `${format(dateRange[0].startDate, "yyyy-MM-dd")} - ${format(dateRange[0].endDate, "yyyy-MM-dd")}`
                    : "Select Date Range"}
                </div>
              </div>
            </div>
            <ColourFilterBox
              title="Production Group"
              items={productionGroupList}
              search={search.productionGroup}
              setSearch={(val) => handleSearch("productionGroup", val)}
              selectedItems={filters.productionGroup}
              toggleItem={(item) => toggleItem("productionGroup", item)}
              selectAll={() =>
                selectAll("productionGroup", productionGroupList)
              }
            />

            <ColourFilterBox
              title="Machine Group Name"
              items={machineGroupList}
              search={search.machineGroup}
              setSearch={(val) => handleSearch("machineGroup", val)}
              selectedItems={filters.machineGroup}
              toggleItem={(item) => toggleItem("machineGroup", item)}
              selectAll={() => selectAll("machineGroup", machineGroupList)}
            />
            <Button
              onClick={handleSubmit}
              style={{
                width: "100%",
                height: "44px",
                borderRadius: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour12,
                border: "none",
                fontWeight: "700",
                padding: "12px"
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Col>

        {/* 🔥 RIGHT CONTENT */}
        <Col xl={9} lg={8} md={12} sm={12}>
          <Row>
            {MachineWiseCostingdata?.Detail?.length > 0 ? (
              MachineWiseCostingdata?.Detail?.map((item, index) => (
                <Col xl={3} lg={4} md={6} sm={6} xs={12} className="mb-3">
                  <div
                    style={{
                      background:
                        isdark === "light"
                          ? iscolour?.Colour2
                          : iscolourDark?.Colour2,
                      borderRadius: "18px",
                      padding: "16px",
                      border: `1px solid ${isdark === "light"
                        ? iscolour?.Colour3
                        : iscolourDark?.Colour5
                        }`,
                      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    }}
                  >
                    {/* 🔷 Title */}
                    <div
                      style={{
                        fontWeight: "600",
                        fontSize: "14px",
                        marginBottom: "12px",
                        color:
                          isdark === "light"
                            ? iscolour?.Colour7
                            : iscolourDark?.Colour9,
                      }}
                    >
                      {item.MachineMstName}
                    </div>

                    {/* 🔷 COST */}
                    <div
                      style={{
                        border: `2px solid ${isdark === "light"
                          ? iscolour?.Colour4
                          : iscolourDark?.Colour5
                          }`,
                        padding: "12px",
                        borderRadius: "12px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px",
                        background:
                          isdark === "light"
                            ? iscolour?.Colour3
                            : iscolourDark?.Colour4,
                      }}
                    >
                      <span
                        style={{
                          fontSize: "12px",
                          color:
                            isdark === "light"
                              ? iscolour?.Colour8
                              : iscolourDark?.Colour8,
                        }}
                      >
                        COST
                      </span>
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                          color:
                            isdark === "light"
                              ? iscolour?.Colour8
                              : iscolourDark?.Colour9,
                        }}
                      >
                        {(item.Cost || 0).toFixed(2)}
                      </span>
                    </div>

                    {/* 🔷 AMOUNT */}
                    <div
                      style={{
                        border: `2px solid ${isdark === "light"
                          ? iscolour?.Colour4
                          : iscolourDark?.Colour5
                          }`,
                        padding: "12px",
                        borderRadius: "12px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px",
                        background:
                          isdark === "light"
                            ? iscolour?.Colour3
                            : iscolourDark?.Colour4,
                      }}
                    >
                      <span
                        style={{
                          fontSize: "12px",
                          color:
                            isdark === "light"
                              ? iscolour?.Colour7
                              : iscolourDark?.Colour8,
                        }}
                      >
                        AMOUNT
                      </span>
                      <span
                        style={{
                          fontSize: "16px",
                          color:
                            isdark === "light"
                              ? iscolour?.Colour7
                              : iscolourDark?.Colour6,
                          fontWeight: "bold",
                        }}
                      >
                        ₹{Number(item.Amt || 0).toFixed(2)}
                      </span>
                    </div>

                    {/* 🔷 METER */}
                    <div
                      style={{
                        background:
                          isdark === "light"
                            ? iscolour?.Colour3
                            : iscolourDark?.Colour4,
                        padding: "12px",
                        borderRadius: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        border: `2px solid ${isdark === "light"
                          ? iscolour?.Colour4
                          : iscolourDark?.Colour5
                          }`,
                      }}
                    >
                      <span
                        style={{
                          fontSize: "12px",
                          color:
                            isdark === "light"
                              ? iscolour?.Colour7
                              : iscolourDark?.Colour8,
                        }}
                      >
                        METER
                      </span>
                      <span
                        style={{
                          fontSize: "16px",
                          color:
                            isdark === "light"
                              ? iscolour?.Colour8
                              : iscolourDark?.Colour9,
                          fontWeight: "bold",
                        }}
                      >
                        {Number(item.Meter || 0).toFixed(2)}
                      </span>
                    </div>
                  </div>
                </Col>
              ))
            ) : (
              <Col xs={12}>
                <div
                  style={{
                    textAlign: "center",
                    padding: "40px",
                    borderRadius: "12px",
                  }}
                >
                  <h4>No Machine Data Available</h4>
                  <p>Please select filters and click Apply Filters</p>
                </div>
              </Col>
            )}
          </Row>
        </Col>
      </Row>

      {/* 🔥 DATE PICKER */}
      {showDatePicker && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
          onClick={() => setShowDatePicker(false)}
        >
          <ColorCalenderCss
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3,

              borderRadius: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Calendar
              className="custom-calendar"
              selectRange={true}
              onChange={(value) => {
                if (Array.isArray(value)) {
                  setDateRange([
                    {
                      startDate: value[0],
                      endDate: value[1],
                      key: "selection",
                    },
                  ]);
                }
              }}
              value={
                dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? [dateRange[0].startDate, dateRange[0].endDate]
                  : null
              }
            />

            <div
              className="date-picker-footer"
              style={{
                textAlign: "center",
                marginTop: "15px",
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour3,
                borderRadius: "0 0 20px 20px",
              }}
            >
              <button
                onClick={() => setShowDatePicker(false)}
                style={{
                  padding: "10px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "700",
                  color: "#fff",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour7
                      : iscolourDark?.Colour7,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                  transition: "0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.85";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.transform = "scale(1)";
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
